export default __webpack_public_path__ + "static/image12-0b2605d5b494f44fc78a9bc35bab7f73.gif";